// pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import {
  Box, Button, FormControl, FormLabel, Input, Stack, Text, useToast, Heading, Flex, useColorModeValue,
} from '@chakra-ui/react';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
      await axios.post(`${backendUrl}/request-reset`, { email });

      toast({
        title: 'Reset link sent!',
        description: 'Check your inbox for password reset instructions.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      console.error(err);
      toast({
        title: 'Failed to send reset link.',
        description: 'Please check the email and try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const bg = useColorModeValue('white', 'black');

  return (
    <Flex minH={'100vh'} align={'center'} justify={'center'} bg={bg}>
      <Stack spacing={8} maxW={'md'} w={'full'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'3xl'}>Reset your password</Heading>
          <Text fontSize={'md'} color={'gray.500'}>
            We’ll send you a link to reset it.
          </Text>
        </Stack>
        <Box rounded={'lg'} bg={bg} boxShadow={'lg'} p={8}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={4}>
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <Button type="submit" colorScheme="blue" width="full">
                Send Reset Link
              </Button>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};

export default ForgotPasswordPage;
